// components
import {
  ControlledDatePicker,
  ControlledTextField
} from 'components/shared/ControlledFields';
import {
  GridContainer,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

// hooks
import { useTranslation } from 'react-i18next';

// utils
import { Control } from 'react-hook-form';
import { dateFormatter } from 'utils/grid';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';

const NameFieldWithReadMode = withReadModeField(ControlledTextField);
const DescriptionFieldWithReadMode = withReadModeField(ControlledTextField);
const ValidFromFieldWithReadMode = withReadModeField(ControlledDatePicker);
const ValidToFieldWithReadMode = withReadModeField(ControlledDatePicker);

type Props = {
  control: Control<any>;
};

export default function EditProjectForm({ control }: Props) {
  const { t } = useTranslation();

  return (
    <GridContainer mb={2.5}>
      <GridCompact6>
        <NameFieldWithReadMode
          name="name"
          control={control}
          label={t('name')}
          variant="outlined"
        />
      </GridCompact6>
      <GridCompact6>
        <DescriptionFieldWithReadMode
          name="description"
          control={control}
          label={t('description')}
          variant="outlined"
        />
      </GridCompact6>
      <GridCompact6>
        <ValidFromFieldWithReadMode
          name="validFrom"
          control={control}
          label={t('validFrom')}
          variant="outlined"
          fullWidth
          valueFormatter={dateFormatter}
        />
      </GridCompact6>
      <GridCompact6>
        <ValidToFieldWithReadMode
          name="validTo"
          control={control}
          label={t('validTo')}
          variant="outlined"
          fullWidth
          valueFormatter={dateFormatter}
        />
      </GridCompact6>
    </GridContainer>
  );
}
